import { ImagenActionType } from './enums';
import { ImagenState, ImagenAction } from './interfaces';

export const initialState: ImagenState = {
	isGenerating: false,
	generatedImage: null,
	error: null,
	lastGeneratedAt: null,

	// Upload state
	isUploading: false,
	uploadedDocumentId: null,
	uploadedImageUrl: null
};

export default (state = initialState, { type, payload }: ImagenAction): ImagenState => {
	switch (type) {
		case ImagenActionType.UPLOAD_IMAGE_REQUEST:
			return {
				...state,
				isUploading: true,
				error: null
			};

		case ImagenActionType.UPLOAD_IMAGE_SUCCESS:
			return {
				...state,
				isUploading: false,
				uploadedDocumentId: payload.documentId,
				uploadedImageUrl: payload.imageUrl,
				error: null
			};

		case ImagenActionType.UPLOAD_IMAGE_FAILURE:
			return {
				...state,
				isUploading: false,
				error: payload.error
			};

		case ImagenActionType.GENERATE_RENDER_REQUEST:
			return {
				...state,
				isGenerating: true,
				error: null
			};

		case ImagenActionType.GENERATE_RENDER_SUCCESS:
			return {
				...state,
				isGenerating: false,
				generatedImage: payload.imageData,
				lastGeneratedAt: Date.now(),
				error: null
			};

		case ImagenActionType.GENERATE_RENDER_FAILURE:
			return {
				...state,
				isGenerating: false,
				error: payload.error
			};

		case ImagenActionType.CLEAR_GENERATED_RENDER:
			return {
				...state,
				generatedImage: null,
				error: null
			};

		default:
			return state;
	}
};
